if (!window.SembvRecentlyViewed) {
  const SEMBV_RECENTLY_VIEWED_STORAGE_KEY = 'sembv:recently-viewed-products';
  const SEMBV_RECENTLY_VIEWED_MAX_STORED = 24;

  const sembvGetRecentlyViewedHandles = function () {
    try {
      const raw = localStorage.getItem(SEMBV_RECENTLY_VIEWED_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const sembvRecordRecentlyViewedProduct = function (handle) {
    if (!handle) return;

    try {
      const handles = sembvGetRecentlyViewedHandles().filter((existing) => existing !== handle);
      handles.unshift(handle);
      localStorage.setItem(
        SEMBV_RECENTLY_VIEWED_STORAGE_KEY,
        JSON.stringify(handles.slice(0, SEMBV_RECENTLY_VIEWED_MAX_STORED))
      );
    } catch (error) {
      // localStorage unavailable (private browsing, storage disabled, ...): fail silently
    }
  };

  window.SembvRecentlyViewed = {
    record: sembvRecordRecentlyViewedProduct,
    getHandles: sembvGetRecentlyViewedHandles,
  };

  if (!customElements.get('recently-viewed-products')) {
    customElements.define(
      'recently-viewed-products',
      class RecentlyViewedProducts extends HTMLElement {
        connectedCallback() {
          this.currentHandle = this.dataset.currentProductHandle || '';
          this.maxProducts = parseInt(this.dataset.maxProducts, 10) || 6;
          this.list = this.querySelector('[data-recently-viewed-list]');

          this.renderProducts();
        }

        async renderProducts() {
          if (!this.list) return;

          const handles = sembvGetRecentlyViewedHandles()
            .filter((handle) => handle && handle !== this.currentHandle)
            .slice(0, this.maxProducts);

          if (!handles.length) return;

          const cards = await Promise.all(handles.map((handle) => this.fetchCard(handle)));
          const validCards = cards.filter(Boolean);

          if (!validCards.length) return;

          validCards.forEach((card) => this.list.appendChild(card));
          this.hidden = false;
        }

        async fetchCard(handle) {
          try {
            const response = await fetch(`/products/${handle}?section_id=card-product-ajax`);
            if (!response.ok) return null;

            const text = await response.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            return doc.querySelector('.o-product__item');
          } catch (error) {
            return null;
          }
        }
      }
    );
  }
}
